/*
 * @FilePath: /lark-activity/src/utils/regular.ts
 * @Description:
 */

export default {
  phone: /^1[3-9][0-9]{9}$/,
  password: /(?![0-9A-Z]+$)(?![0-9a-z]+$)(?![a-zA-Z]+$)[0-9A-Za-z~!@#$%^&*()/\\|,.<>?"'();:_+-=\\[\]{}]{8,20}$/
}
